/**
 * Можно ли отдавать кадр наружу.
 *
 * Скачанная картинка живёт своей жизнью — в отчёте, в переписке, в
 * презентации, — и проверить её нечем: единиц нет, координат нет, значение это
 * цвет. Пустое поле на такой картинке неотличимо от честного «здесь ничего
 * нет», то есть от измерения, которого никто не делал. Поэтому кнопка гаснет,
 * а не отдаёт кадр с оговоркой.
 *
 * Причина называется ВСЕГДА: молча пропавшая кнопка отправляет человека искать
 * её в настройках, тогда как искать надо кнопку «Загрузить» рядом.
 */

export type LayerShowState =
  /** Растрового слоя на карте нет — кадр без полей. */
  | 'none'
  /** Тайлы на месте, поле видно. */
  | 'ready'
  /** Поле в базе есть, тайлы ещё считаются. */
  | 'rendering'
  /** Данных за дату нет вовсе. */
  | 'no-data'

export interface ExportReadyState {
  ok: boolean
  /** Ключ причины отказа; null — отказа нет. */
  hintKey: string | null
}

export function exportReadyState(state: LayerShowState): ExportReadyState {
  // Слоя нет — пропускам взяться неоткуда. Чистая карта с судами, косяками и
  // координатной сеткой законна сама по себе, и запрет отнял бы у промысловика
  // обстановку без полей.
  if (state === 'none' || state === 'ready') return { ok: true, hintKey: null }
  return {
    ok: false,
    hintKey: state === 'rendering' ? 'map.export.notReadyTiles' : 'map.export.notReadyData',
  }
}

/**
 * Состояние слоя из того, что знает страница.
 *
 * Обе витрины отвечают на один и тот же вопрос своими словами: «Карты» держат
 * флаги показа и докрашивания, «Аналитика» спрашивает готовность запросом.
 * Свод в одну функцию нужен, чтобы правило не разъехалось по двум страницам —
 * ровно та же болезнь, что была у палитр в десяти местах.
 *
 * `shown` — поле под слоем есть (пусть и в виде серых плиток);
 * `rendering` — тайлы ещё считаются.
 */
export function layerStateOf(shown: boolean, rendering: boolean): LayerShowState {
  if (!shown) return 'no-data'
  return rendering ? 'rendering' : 'ready'
}
